import React, { useState,  useRef } from 'react';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import styles from './batchtable.module.css';
import { useHistory } from "react-router-dom";
// import { classNames } from "primereact/utils";
import axios from '../../axios-vmou';

const Awlreprint = (props) => {

    const toast = useRef(null);
    // const [submitted, setSubmitted] = useState(false);
    const [selectedBatch, setSelectedBatch] = useState('');
    const history = useHistory()

    
    const examSearch = (event) => {
        event.preventDefault();  
        let authOptions = {
            method: "GET",
            url: "/batch/"+selectedBatch,
            data: { 'userid': props.userid },
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          };
          axios(authOptions)
            .then((response) => {
                history.push({
                    pathname: '/AwlPrint',
                    state: {batch:response.data}
                });
            })
            .catch((error) => {
              toast.current.show({
                severity: "error",
                summary: "Error Message",
                detail: error.response.data,
              });
            });
            
    }
    return (
    <div className={styles.datatablecruddemo}>
        <Toast ref={toast} />
        <div className={styles.Sformpr}>
            <div className=" ">
                <label htmlFor="centre" className="">Enter Batch Code</label>
                <InputText id="name" value={selectedBatch} onChange={(e) => setSelectedBatch(e.target.value)} required
                // className={classNames({ "p-invalid": submitted && !selectedBatch })}
                />
                {/* {submitted && !selectedBatch && (
                    <small className="p-error">Name is required.</small> */}
                {/* )} */}
            </div>
            <Button icon="pi pi-print" className="ml-2 p-button-text p-button-success" onClick={examSearch}/>
        </div>
    </div>
    );
}
const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
  }
  
  export default connect(mapStateToProps)(Awlreprint);